const TOKEN = 'token';
const REFRESH_TOKEN = 'refresh_token';
const SESSION_TIME = 'session_time';
const COUNTDOWN_TIME = 'countdown_time';

export type StorageTokens = {
  token?: string;
  refreshToken?: string;
  sessionTime?: string;
  countDownTime?: string;
};

const storage = {
  GetTokens: (): StorageTokens => {
    return {
      token: localStorage.getItem(TOKEN) ?? undefined,
      refreshToken: localStorage.getItem(REFRESH_TOKEN) ?? undefined,
      sessionTime: localStorage.getItem(SESSION_TIME) ?? undefined,
      countDownTime: localStorage.getItem(COUNTDOWN_TIME) ?? undefined,
    };
  },
  SetTokens: (tokens: StorageTokens) => {
    if (tokens.token) localStorage.setItem(TOKEN, tokens.token);
    if (tokens.refreshToken)
      localStorage.setItem(REFRESH_TOKEN, tokens.refreshToken);
    if (tokens.sessionTime)
      localStorage.setItem(SESSION_TIME, tokens.sessionTime);
    if (tokens.countDownTime)
      localStorage.setItem(COUNTDOWN_TIME, tokens.countDownTime);
  },
  ClearTokens: () => {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(REFRESH_TOKEN);
    localStorage.removeItem(SESSION_TIME);
    localStorage.removeItem(COUNTDOWN_TIME);

  },
  SetAccessToken: (token: string) => {
    localStorage.setItem(TOKEN, token);
  },
};

export default storage;
